// extracted by mini-css-extract-plugin
module.exports = {"landing":"LandingAboutUs_landing__1DDCH"};